/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceCategory = 'INTERNAL' | 'EXTERNAL' | 'POC' | 'ENGINEERING' | 'ENGINEERING_SM' | 'ENGINEERING_QA' | 'ENGINEERING_BA' | 'ENGINEERING_FS' | 'ENGINEERING_SP';

export const ResourceCategory = {

    INTERNAL: 'INTERNAL' as ResourceCategory,

    EXTERNAL: 'EXTERNAL' as ResourceCategory,

    POC: 'POC' as ResourceCategory,

    ENGINEERING: 'ENGINEERING' as ResourceCategory,

    ENGINEERING_SM: 'ENGINEERING_SM' as ResourceCategory,

    ENGINEERING_QA: 'ENGINEERING_QA' as ResourceCategory,

    ENGINEERING_BA: 'ENGINEERING_BA' as ResourceCategory,

    ENGINEERING_FS: 'ENGINEERING_FS' as ResourceCategory,

    ENGINEERING_SP: 'ENGINEERING_SP' as ResourceCategory
};

